import { axiosInstance } from '.';
const getPaymentTransactionsList = async (params) => await axiosInstance.get('/payment_transactions', { params });
const ExportPaymentTransactions = async (params) => await axiosInstance.get('/payment_transactions/generate_report', { params });
export{
    getPaymentTransactionsList,
    ExportPaymentTransactions
}